export default "/images/stripe-icon.svg?94ee0e39b69808bcdc69611aefbf35da";